import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact} from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import './proveedortable.css'
import { FaFileContract } from 'react-icons/fa'
import { warning } from "../../../../../utils/notifications"
import { EditModalDialog } from "./EditModalDialog/EditModalDialog"
import { defaultRenderer, percentRenderer } from "../../../../../utils/helperFunctions"
import { UserContext } from "../../../../../Redux/UserContext"


export const ProveedorTableSimple:FC<any> = (props):JSX.Element => {

    const { data, dataMASTER, setData, simulated,original, setStep, setSelectedProvider, saveLoading, scenarioBase } = props

    const [state] = useContext(UserContext)
    
    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }

    const gridRef :any= useRef();


    const handleViewContracts = (params:any) => {
        setSelectedProvider(params.data)
        setStep(false)
    }

    const viewContractsRenderer = (params:any) => {
        return <FaFileContract size={20} style={{cursor:"pointer"}} onClick={() => handleViewContracts(params)}  />
    }

    
    const handleEditCellContent = (params:any) => {
        let { colId } = params.column
        
        if(colId !== 'name_provider' && colId !== 'numero_camiones_a') {
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                }  else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleCellStyleEditable = (params:any) => {
        let original = dataMASTER.provider_table.find((ori:any) => ori.id_provider === params.data.id_provider)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const handleCellStyle = (params:any) => {
        let original = dataMASTER.provider_table.find((ori:any) => ori.id_provider === params.data.id_provider)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    

    return (
        <div className="proveedortable__wrapper">
            <EditModalDialog
                visible={visible}
                setVisible={setVisible}
                handleClose={handleClose}
                selectedCell={selectedCell}
                setSelectedCell={setSelectedCell}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                mode={mode}
                setMode={setMode}
                data={data}
                dataMASTER={dataMASTER}
                setData={setData}
                type={"P"}

                
            />
            
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '100%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '100%' }}>
                {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                    :
                        false
                }
               
                <div className="contrato_back_btn">
                    <span><b> </b></span>
                </div>
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContent : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.provider_table}
                    enableCellTextSelection>
                    <AgGridColumn sort={'desc'}  resizable={true} flex={1} hide  field={"id"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyle}   suppressNavigable={true} hide  headerName={"Proveedor"} field={"id_provider"}></AgGridColumn>

                    <AgGridColumn headerClass={"header-border header-resize"} sortable filter={true} cellStyle={handleCellStyle}  suppressNavigable={true} flex={2} headerName={"Proveedor"} field={"name_provider"}></AgGridColumn>
                    
                        <AgGridColumn cellStyle={handleCellStyleEditable} headerClass={"header-resize"} sortable  suppressNavigable flex={1} cellRenderer={percentRenderer}  headerName="% Cumplimiento objetivo" field="porcentaje_cumplimiento_objetivo_a"></AgGridColumn>
                        
                    
                    
                        <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-resize"}  sortable  suppressNavigable flex={1} cellRenderer={defaultRenderer}   headerName="Número camiones" field="numero_camiones_a"></AgGridColumn>
                    
                  
                    
                    <AgGridColumn   suppressNavigable={true} headerClass={"header-resize"} sortable maxWidth={120} cellStyle={{color:'black'}}  cellRenderer={viewContractsRenderer}  headerName={"Contratos"}></AgGridColumn>

                </AgGridReact>
            </div>
            
        </div>
        
    )
}